module.exports = __webpack_public_path__ + "static/media/1-02.32608fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/1-02.jpg
// module id = 167
// module chunks = 0